import { LoginForm } from '@/components/auth/LoginForm'

export function LoginPage() {
  return <LoginForm />
}
